import React from 'react';
import { FormikProps } from 'formik';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { InstitutionProps } from '../../models/arc-epi-props';
import { OfficerAddFormValues, WithAccessTo } from './officer-add-form-model';
import { PersonFieldsDisplay } from '../../../account-info/components/read-only/person-fields-display';
import { MailingAddressDisplay } from '../../../account-info/components/read-only/mailing-address-display';
import { PhonesDisplay } from '../../../account-info/components/read-only/phones-display';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { BusinessEmailRequiredDisplay } from '../person-search/business-email-required';
import { SearchPerson } from '../person-search/person-search-model';
import { YesNoIndicators } from '../../../../global/models/api-model';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { PersonEmailRequiredDisplay } from '../person-search/person-email-required';

interface Props {
	labelSetting: LabelSettingProps;
	institutionProps: InstitutionProps;
	formProps: FormikProps<OfficerAddFormValues>;
	selectedPerson?: SearchPerson;
}
export function OfficerAddConfirmation(props: Props) {

	const { labelSetting, formProps, institutionProps, selectedPerson } = props;
	const { values } = formProps;
	const mapRole = values.withAccessTo?.includes(WithAccessTo.map) ? institutionProps.mapOptionText : '';
	const cicRole = values.withAccessTo?.includes(WithAccessTo.cic) ? institutionProps.cicOptionText : '';
	const displayComma = mapRole && cicRole;
	const withAccessToValue = `${mapRole} ${displayComma && ', '}${cicRole}`;
	return (
		<>
			<DividerSection removeDivider>
				<BusinessEmailRequiredDisplay
					businessEmailLabel={labelSetting?.businessEmailLabel}
					formProps={formProps}
					selectedPerson={selectedPerson}
				/>
				<PersonEmailRequiredDisplay
					personEmailLabel={labelSetting?.personalEmailLabel}
					formProps={formProps}
					selectedPerson={selectedPerson}
				/>
			</DividerSection>

			<DividerSection removeDivider sectionText={institutionProps.officerInformationSectionTitle}>
				<LabelAndValue label={institutionProps.personTypeConfirmationLabel} value={values.nonEpiscopal === YesNoIndicators.Yes ? institutionProps.nonEpiscopalInstitutionEmployeeOptionText : institutionProps.episcopalInstitutionEmployeeOptionText} />
				<LabelAndValue label={institutionProps.withAccessLabel} value={withAccessToValue} />
			</DividerSection>

			<PersonFieldsDisplay
				labelSetting={labelSetting}
				values={values}
				sectionText={institutionProps.personalInformationSectionTitle}
				dobMasked={!!selectedPerson}
			/>
			<MailingAddressDisplay
				labelSetting={labelSetting}
				values={values}
			/>

			<PhonesDisplay
				labelSetting={labelSetting}
				values={values}
			/>
		</>
	);
}

OfficerAddConfirmation.defaultProps = {
	selectedPerson: null,
};